import React from 'react'

export default function PaymentForm() {
  return (
  <>
     <div className='payment--box'>
                           <div className='payment--box--card'>
                            <img src="IMG_8837.jpg" alt="" />
                            <div className='payment--box--card--desc'>
                              <p>Veuillez nous parvenir la capture de votre paiement sur ce numéro whatsapp +225 07 49 69 88 48</p>
                            </div>
                            </div>
                      </div>
  </>
  )
}
